"use strict";

var _slicedToArray = require("/vercel/path0/react/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var useSetState = function useSetState() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _react_1$useState = react_1.useState(initialState),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      state = _react_1$useState2[0],
      set = _react_1$useState2[1];

  var setState = function setState(patch) {
    set(function (prevState) {
      return Object.assign({}, prevState, patch instanceof Function ? patch(prevState) : patch);
    });
  };

  return [state, setState];
};

exports.default = useSetState;